// material-ui

import manualmodewhicon from '../../../assets/images/manual-mode-wh.svg';
/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

const ManualModeWhIcon = () => {
    

    return (
        /**
         * if you want to use image instead of svg uncomment following, and comment out <svg> element.
         *
         * <img src={logo} alt="Berry" width="100" />
         *
         */
         <img src={manualmodewhicon} alt="Manual Mode" width="22"  />
    );
};

export default ManualModeWhIcon;